import React from "react";
import { SbTooltip, SbInfoTooltip } from "uiCore";
import { INDEX_FULL_NAMES } from "../talentMobility.constants";

// Hover-reveal of an index acronym's full name (SMI/SRI/SSI — see
// INDEX_FULL_NAMES). Wraps whatever renders the acronym — typically a score
// SbTag — in the same SbTooltip pattern PaicOrgRedesignV2's Old/New SRI tags
// use.
export const IndexTooltip = ({ index, children, ...rest }) => (
  <SbTooltip content={INDEX_FULL_NAMES[index]} {...rest}>
    {children}
  </SbTooltip>
);

// Label + info-icon variant for table column titles, standalone stat labels,
// and acronym mentions in running text — the SbInfoTooltip form-label pattern
// used app-wide. With no children the bare acronym is the label.
export const IndexInfoLabel = ({ index, children, ...rest }) => (
  <SbInfoTooltip content={INDEX_FULL_NAMES[index]} {...rest}>
    {children ?? index}
  </SbInfoTooltip>
);

export default IndexTooltip;
